import {
  HttpClient,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin } from 'rxjs';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { flatMap } from 'rxjs/operators';
import {
  SERVER_URL,
} from '../../../environments/environment';
import {
  getWebMethods,
  addWebMethods
} from '../../shared/util/webmethods';
import { Http, Headers, RequestOptions } from '@angular/http';
import { ReceivePO } from '../../shared/Interface/receivepo';


@Injectable({
  providedIn: 'root'
})

export class EntityDataService {
  rootURL = SERVER_URL;
  poHeaderArray: any = [];
  myPoDidSelectRowArray: any = [];
  data: any = [];
  constructor(private httpClient: HttpClient, public http: Http) {
  }


  // savePoHeaderData(array: any) {
  //   this.poHeaderArray = array;
  // }

  // retrievePoData() {
  //   return this.poHeaderArray;
  // }

  setParams(array1: any) {
    this.myPoDidSelectRowArray = array1;
  }

  getParams() {
    return this.myPoDidSelectRowArray;
  }

  //fetch list of POs for approval page with given status
  getApprovalsEntity$(orgId, mrgId, type, requestType): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.reqForApprovalMgr,
      this.bodyForRequest(orgId, mrgId, type, requestType, "", "", "", "", "", ""),
      this.httpApiHeader()
    );
    return response;
  }

  //fetch expenses/POs based on user within given date window
  getExpensesEntity$(userId, type, fromDate, toDate, compCode): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.expenses,
      this.bodyForRequest(userId, type, fromDate, toDate, compCode, "", "", "", "", ""),
      this.httpApiHeader()
    );
    return response;
  }


  //fetch addExpenseEntity based on user within given date window
  addExpenseEntity(lineItemRequestParams) {
    return new Promise(resolve => {
      let header = new Headers();
      header.append("Content-Type", "application/json");
      let options = new RequestOptions({ headers: header });
      let body = '';
      body = JSON.stringify(lineItemRequestParams);

      // console.log('serviceURL: ' + this.rootURL + getWebMethods.saveLineItem + '  body: ' + body + '  options: ' + options);
      this.http.post(this.rootURL + getWebMethods.saveLineItem, body, options)
        .map(res => res.json()).subscribe(data => {
          // console.log("inner data :" + (data));
          this.data = data;
          resolve(this.data);
        }, err => {

          // console.log("error: " + err);
          this.data = err;
          resolve(this.data);
        });
    });
  }

  //fetch addExpenseEntity based on user within given date window
  addExpense1Entity(poInfoRequestParams) {
    return new Promise(resolve => {
      let header = new Headers();
      header.append("Content-Type", "application/json");
      let options = new RequestOptions({ headers: header });
      let body = '';
      body = JSON.stringify(poInfoRequestParams);
      // console.log('serviceURL: ' + this.rootURL + getWebMethods.saveLineItem + '  body: ' + body + '  options: ' + options);
      this.http.post(this.rootURL + getWebMethods.savePoInfo, body, options)
        .map(res => res.json()).subscribe(data => {
          this.data = data;
          resolve(this.data);
        }, err => {
          // console.log("error: " + err);
          this.data = err;
          resolve(this.data);
        });
    });
  }

  getCodes$(orgId, compCode, codeId): Observable<any> {
    return this.getReqIdEntity$(orgId, compCode, codeId);
  }

  //get comments
  getCommentsEntity$(reqId, orgId): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.getComments,
      this.bodyForRequest(reqId, orgId, "", "", "", "", "", "", "", ""),
      this.httpApiHeader()
    )
    return response;
  }

  //fetch Auto ReqIDs, preferVendor & mgrEmails
  getReqIdEntity$(orgId, compCode, seqId): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.generateReqId,
      this.bodyForRequest(orgId, compCode, seqId, "", "", "", "", "", "", ""),
      this.httpApiHeader()
    )
    return response;
  }

  //fetch Auto ReqIDs, preferVendor & mgrEmails
  getUnallocatedPermissionEntity$(orgId, compCode, seqId): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.getCodes,
      this.bodyForRequest(orgId, compCode, seqId, "", "", "", "", "", "", ""),
      this.httpApiHeader()
    )
    return response;
  }

  //fetch pVendor
  getPVendorsEntity$(orgId, compCode, expenseItem, city): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.preferredVendors,
      this.bodyForRequest(orgId, "", compCode, "", "", "", "", "", "", ""),
      this.httpApiHeader()
    );

    return response;
  }

  //fetch vendorPartNo List
  vendorPartNoDataEntity$(orgId, compCode, vendorId): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.vendorPartNoItems, this.bodyForVendorPartNoRequest(orgId, compCode, vendorId),
      this.httpApiHeader()
    );
    return response;
  }



  // addCommnetsEntity
  addCommnetsEntity$(varReqId, orgId, comments, userId) {
    //console.log("addCommnetsEntity: " + varReqId + comments + orgId + userId);
    return new Promise(resolve => {
      let header = new Headers();
      header.append("Content-Type", "application/json");
      let options = new RequestOptions({ headers: header });
      let body = '';
      body = this.bodyForAddCommetsRequest(varReqId, orgId, comments, userId, "", "", "", "", "", "");
      // console.log('serviceURL: ' + this.rootURL + getWebMethods.addComment + '  body: ' + body + '  options: ' + options);
      this.http.post(this.rootURL + getWebMethods.addComment, body, options)
        .map(res => res.json()).subscribe(data => {
          this.data = data;
          resolve(this.data);
        }, err => {
          // console.log("error: " + err);
          this.data = err;
          resolve(this.data);
        });
    });

  }


  //fetch ManagerEmails
  getManagerEmailsEntity$(userId, orgId, compCode, type): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.managersEmails,
      this.bodyForRequest(userId, orgId, compCode, type, "", "", "", "", "", ""),
      this.httpApiHeader()
    );
    return response;
  }

  // .map(products => {
  //   return products.map((product) => new Product(product));
  // })

  //fetch receving Po
  getReceivingPODetailsEntity$(userId, type, compCode, pVendor): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.getReceivingPODetails,
      this.bodyForRequest(userId, type, compCode, pVendor, "", "", "", "", "", ""),
      this.httpApiHeader()
    );
    return response;
  }


  //fetch receving Po
  addPOReceiveMulsEntity$(list): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.addPOReceiveMul, JSON.stringify(list),
      this.httpApiHeader()
    );
    return response;
  }


  //fetch profiles based on usergroup
  getUserGroupProfileEntity$(orgId, compCode, userGroup): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.userGrpProfile,
      this.bodyForRequest(orgId, "", compCode, userGroup, "", "", "", "", "", ""),
      this.httpApiHeader()
    );
    return response;
  }

  //fetch logged in user details
  getUserEntity$(email: String): Observable<any> {
    let response =
      this.httpClient.post(
        this.rootURL + getWebMethods.userDetails,
        email
      );
    var userInfo$ = forkJoin([response]);
    var observer = userInfo$
      .pipe(
        flatMap((data: any) =>
          this.getUserGroupProfileEntity$(data[0][0].orgId, data[0][0].compCode, data[0][0].userGroup)
            .map(
              userProfile => ({ data, userProfile })
            )
        )
      )
    return observer;
  }

  //fetch departments
  getDeptListEntity$(orgId, compCode, codeValue): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.deptCodes,
      this.bodyForRequest(orgId, "", codeValue, compCode, "", "", "", "", "", ""),
      this.httpApiHeader()
    );
    return response;
  }

  //fetch Status Desription
  getStatusEntity$(orgId, compCode, codeValue): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.deptCodes,
      this.bodyForRequest(orgId, "", codeValue, compCode, "", "", "", "", "", ""),
      this.httpApiHeader()
    );
    return response;
  }

  //fetch ExpItemsByDept
  getExpItemsByDeptEntity$(orgId, type, compCode, dept, expType): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.expItemsByDept,
      this.bodyForRequest(orgId, type, compCode, dept, expType, "", "", "", "", ""),
      this.httpApiHeader()
    );
    return response;
  }

  //fetch DeptBudgetDetails
  getDeptBudgetDetailsEntity(accountCode, orgId, compCode, deptCode, year, month): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.deptBudgetDetails,
      this.bodyForPOBudgetRequest(accountCode, orgId, compCode, year, month, deptCode),
      this.httpApiHeader()
    );
    return response;
  }

  //fetch FicalCalender
  getFicalCalenderEntity$(orgId, year, compCode): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.fiscalCalendar,
      this.bodyForRequest(orgId, year, compCode, "", "", "", "", "", "", ""),
      this.httpApiHeader()
    );
    return response;
  }

  //fetch getlineItemDetailsEntity
  getlineItemDetailsEntity$(orgId, reqID): Observable<any> {
    let response = this.httpClient.post(
      this.rootURL + getWebMethods.expDetailsByReqId,
      this.bodyForRequest(orgId, reqID, "", "", "", "", "", "", "", ""),
      this.httpApiHeader()
    );
    return response;
  }


  //fetch current version of the application
  getVersionEntity$(): Observable<any> {
    let response = this.httpClient.get(this.rootURL + getWebMethods.checkVersion);
    return forkJoin([response]);
  }

  // approveRequestByMgr
  approveRequestByMgrEntity$(
    orgId,
    approved,
    reqId,
    preApproved,
    type,
    accCode,
    seqId,
    statusId,
    status,
    userId,
    addedBy,
    modifiedBy,
    comments,
    mgrGroupCode,
    vendorEmail,
    parkDays,
    parkDate,
    parkComment,
    emailFaxFlag,
    actionBy,
    flag,
    compCode
  ) {

    return new Promise(resolve => {
      let header = new Headers();
      header.append("Content-Type", "application/json");
      let options = new RequestOptions({ headers: header });
      let body = '';
      body = this.bodyRequestForApproveRequestByMgr(
        orgId,
        approved,
        reqId,
        preApproved,
        type,
        accCode,
        seqId,
        statusId,
        status,
        userId,
        addedBy,
        modifiedBy,
        comments,
        mgrGroupCode,
        vendorEmail,
        parkDays,
        parkDate,
        parkComment,
        emailFaxFlag,
        actionBy,
        flag,
        compCode);
      // console.log('serviceURL: ' + this.rootURL + getWebMethods.saveLineItem + '  body: ' + body + '  options: ' + options);
      this.http.post(this.rootURL + getWebMethods.approveRequestByMgr, body, options)
        .map(res => res.json()).subscribe(data => {
          this.data = data;
          resolve(this.data);
        }, err => {
          // console.log("error: " + err);
          this.data = err;
          resolve(this.data);
        });
    });

  }

  bodyRequestForApproveRequestByMgr(param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, param11, param12, param13, param14, param15, param16, param17, param18, param19, param20, param21, param22) {
    return JSON.stringify({
      "orgId": param1,
      "approved": param2, // 1 Approved, 2 Rejected, 3 forward request, 4 approve & fwd, 5 Revert status
      "reqId": param3,
      "preApproved": param4,
      "type": param5, // 2 Approved, 0 Rejected, 2 forward, 2 approve & fwd
      "accCode": param6,
      "seqId": param7,
      "statusId": param8,
      "status": param9,
      "userId": param10,
      "addedBy": param11,
      "modifiedBy": param12,
      "comments": param13,
      "mgrGroupCode": param14,
      "vendorEmail": param15,
      "parkDays": param16,
      "parkDate": param17,
      "parkComment": param18,
      "emailFaxFlag": param19,
      "actionBy": param20,
      "flag": param21,
      "compCode": param22
    });
  }

  bodyForRequest(param1, param2, param3, param4, param5, param6, param7, param8, param9, param10) {
    return JSON.stringify({
      param1: param1,
      param2: param2,
      param3: param3,
      param4: param4,
      param5: param5,
      param6: param6,
      param7: param7,
      param8: param8,
      param9: param9,
      param10: param10
    });
  }

  bodyForPOBudgetRequest(accountCode, orgId, compCode, year, month, dept) {
    return JSON.stringify({
      accountCode: accountCode,
      orgId: orgId,
      compCode: compCode,
      year: year,
      month: month,
      deptCode: dept,
    });
  }

  bodyForVendorPartNoRequest(orgId, compCode, vendorId) {
    return JSON.stringify([{
      orgId: parseInt(orgId),
      compCode: compCode,
      itemID: 0,
      vendorID: parseInt(vendorId),
      type: 3
    }]);
  }

  bodyForAddCommetsRequest(param1, param2, param3, param4, param5, param6, param7, param8, param9, param10) {
    return JSON.stringify({
      param1: param1,
      param2: param2,
      param3: param3,
      param4: param4,
      param5: param5,
      param6: param6,
      param7: param7,
      param8: param8,
      param9: param9,
      param10: param10
    });
  }

  httpApiHeader() {
    return {
      headers: { 'Content-Type': 'application/json' }
    };
  }
}